import {
  PROCESSAMENTO_IA_STATUS_COLOR_MAP,
  TAREFA_STATUS_COLOR_MAP,
} from "@/constants/statusColors";
import { StatusProcessamentoIAMap } from "@workflow/types";
import { cn } from "@/lib/utils";
import { StatusBadge } from "../ui/badge-status";
import { StatusProcessamentoIA } from "@workflow/types";

interface ProcessamentoIAStatusBadgeProps {
  status: StatusProcessamentoIA;
  className?: string;
}

export function ProcessamentoIAStatusBadge({
  status,
  className,
}: Readonly<ProcessamentoIAStatusBadgeProps>) {
  const text = StatusProcessamentoIAMap[status] || status;
  const colorClass =
    PROCESSAMENTO_IA_STATUS_COLOR_MAP[status] || PROCESSAMENTO_IA_STATUS_COLOR_MAP.PENDENTE;

  return (
    <StatusBadge color={colorClass} className={cn(className)}>
      {text}
    </StatusBadge>
  );
}
